export function ucFirst(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


// WEBPACK FOOTER //
// ./libs/chassis-helpers/src/strings.ts